import { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { DateFormatter } from '../../utils/DateFormatter';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function WorkflowSelect() {
    const location = useLocation();
    const [definitions, setDefinitions] = useState([]);
    const navigate = useNavigate();

    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getDataUserToken}`,
    };
    function getSessionStorageOrDefault(key, defaultValue) {
        const stored =  sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
    }
    const [userid] = useState(
        getSessionStorageOrDefault('userid', null)
    );

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/definition?userId=${userid}`, {
            headers,
        })
            .then((res) => res.json())
            .then((data) => setDefinitions(data))
    },[]);

    const cards = [];
    console.log('defs', definitions);
    definitions.forEach(def => {
        cards.push(
            <div className="col-6 lg:col-4 p-3">
                <div className="shadow-2 border-round surface-card mb-3 h-full flex-column justify-content-between flex">
                    <div className="p-4">
                        <div className="flex align-items-center">
                            <span className="inline-flex border-circle align-items-center justify-content-center bg-green-100 mr-3" style={{ width: '38px', height: '38px' }}>
                                <i className="pi pi-globe text-xl text-green-600"></i>
                            </span>
                            <span className="text-900 font-medium text-2xl">{def.name}</span>
                        </div>
                        <div className="text-900 my-3 text-xl font-medium">{def.description || 'No Description Provided'}</div>
                        <p className="mt-0 text-700 line-height-3">Created: {DateFormatter(def.createdAt)}</p>
                        <p className="mt-0 text-700 line-height-3">Last Modified: {DateFormatter(def.updatedAt)}</p>
                        <p className="mt-0 text-700 line-height-3">Folder: {def.folder}</p>
                        <p className="mt-0 text-700 line-height-3">Public: {def.is_public ? 'Yes' : 'No'}</p>
                    </div>
                    <div className="px-4 py-3 surface-100 text-right">
                        <Button 
                            icon="pi pi-arrow-right"
                            className="p-button-rounded p-button-success" 
                            onClick={() => {
                                console.log('clicked navigate');
                                location.state ?
                                navigate('/workflows/run', {state: {definition: def.id, dataSet: location.state.dataSet}}) :
                                navigate('/workflows/run', {state: {definition: def.id}})
                            }} />
                    </div>
                </div>
            </div>
        )
    })

    return (
        <div className="surface-ground">
            <div className="grid">
                {cards}
            </div>
        </div>
    )
}